import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { PatientListService } from '../patient-list/patient-list-service';
import { PatientDetailService } from '../patient-detail/patient-detail.service';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import * as global from '../global'
import { PCCService } from 'src/app/services/pcc.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Patient } from 'src/app/classes/patient';
import { MatDialog } from '@angular/material/dialog';
import { CreateNonPccAllergyIntolerancesDialogComponent } from './non-pcc-allergy-intolerances/create-non-pcc-allergy-intolerances-dialog/create-non-pcc-allergy-intolerances-dialog.component';
import * as moment from 'moment-timezone';
import { FacilityService } from 'src/app/services/facility.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import { userInfo } from 'os';
import { CommonService } from 'src/app/services/common.service';
import { lastValueFrom } from 'rxjs';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { CensusPatientListService } from '../census-patient-list/census-patient-list.service';
import { DrugHistoryConsentDialog } from '../census-patient-list/drug-history-consent-dialog/drug-history-consent-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { CaptureScriptSureEmailDialogComponent } from '../scriptsure/capture-scriptsure-email-dialog/capture-scriptsure-email-dialog.component';
import { PatientScriptSureService } from '../scriptsure/patient-scriptsure.service';
import { CaptureScriptSurePatientDetailDialogComponent } from '../scriptsure/capture-scriptsure-patient-detail-dialog/capture-scriptsure-patient-detail-dialog.component';

@Component({
    selector: 'app-patient-detail',
    templateUrl: './patient-detail.component.html',
    styleUrls: ['./patient-detail.component.css']
})
export class PatientDetailComponent implements OnInit, OnDestroy {
    global = global;
    loading: boolean = false;
    currentUser: any = null;
    patient: any = null;
    tabIndex: Number = 0;
    currentRouteAdmin: Boolean;
    patientFacilityFromRelation:any;
    pccApiData: any = {
        'Observation': '',
        'Episode of Care': {},
        'Medications': '',
        'Coverages': '',
        'Conditions': '',
    };
    @Input() patient_id: any;
    @Output() closePatient = new EventEmitter<any>();
    pccPayerTypes = ["managedCare", "medicaid", "medicareA", "medicareB", "medicareD", "other", "outpatient", "private"];
    isPCCLoggedIn = false;
    companyId: any;
    dialogSubscription: any;
    tab: any='Patient Notes';
    updatedArray: any = [];
    savedTabs: any = [];
    isNurseUser: boolean = false;
    tabs: any = [
        { name: 'Patient Notes', is_active: true },
        { name: 'Wounds', is_active: false, },
        { name: 'Patient Documents', is_active: false },
        { name: 'Admit/Discharge History', is_active: false },
        { name: 'Communication', is_active: false },
        { name: 'Diagnosis List', is_active: false },
        { name: 'Encounter', is_active: false },
        // { name: 'Activity Of Daily Living Score', is_active: false },
        { name: 'Activity Of Daily Living', is_active: false },
        { name: 'Appointment', is_active: false },
        { name: 'Vital Signs', is_active: false },
        { name: 'Medications', is_active: false },
        { name: 'Allergies', is_active: false },
        // { name: 'Medical History', is_active: false },
        { name: 'Coverages', is_active: false },
        { name: 'Immunizations', is_active: false },
        { name: 'Imaging', is_active: false },
        { name: 'Labs', is_active: false },
        { name: 'Nutrition Orders', is_active: false },
    ];
    matrixTabs: any = [
        { name: 'Patient Notes', is_active: true }, 
        { name: 'Wounds', is_active: false, },
        { name: 'Patient Documents', is_active: false },
        { name: 'Admit/Discharge History', is_active: false },
        { name: 'Communication', is_active: false },
        { name: 'Encounter', is_active: false },
        { name: 'Diagnosis List', is_active: false },
        { name: 'Vital Signs', is_active: false },
        { name: 'Medications', is_active: false },
        { name: 'Allergies', is_active: false },
        // { name: 'Medical History', is_active: false },
        { name: 'Coverages', is_active: false },
        { name: 'Immunizations', is_active: false },
        { name: 'Imaging', is_active: false },
        { name: 'Labs', is_active: false },
        { name: 'Nutrition Orders', is_active: false },
    ];
    nonPCCtabs: any = [
        { name: 'Patient Notes', is_active: true },
        { name: 'Wounds', is_active: false, },
        { name: 'Patient Documents', is_active: false },
        { name: 'Diagnosis List', is_active: false },
        { name: 'Admit/Discharge History', is_active: false },
        { name: 'Communication', is_active: false },
        { name: 'Encounter', is_active: false },
        { name: 'Allergies', is_active: false },
        { name: 'Medical History', is_active: false },
        // { name: 'Payer Information', is_active: false },
    ];
    recentNote: any;
    constructor(
        private _patientScriptSureService: PatientScriptSureService,
        private location: Location,
        private loader: NgxUiLoaderService,
        private _authService: AuthService,
        private _patientService: PatientListService,
        private _pccService: PCCService,
        private _patientDetailService: PatientDetailService,
        private dialog: MatDialog,
        private _router: Router,
        private commonService: CommonService,
        private facilityService: FacilityService,
        private _route: ActivatedRoute,
        private companyService: CompanyService,
        private censusPatientListService: CensusPatientListService,
        private _toastr: ToastrService,
        ) {
            this.currentUser = this._authService.currentUser;
            this.currentRouteAdmin=false;
        if (window.location.pathname.includes('company')) {
            this.currentRouteAdmin=true;
            this.companyId = this._route.parent.snapshot.params.id || this.currentUser.company_id;
        }
    }

    async ngOnInit() {
        console.log('this._route.snapshot.params', this._route.snapshot)
        console.log('PATIENT in patient details screen:  ', this.patient)
        this.isPCCLoggedIn = !!this._pccService.pccUserinfo
        this._pccService.pccUserinfo$.subscribe(data => {
            this.isPCCLoggedIn = !!data;
        });

        // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.currentUser = this._authService.currentUser;
        if (this.currentUser.user_type.toLowerCase() === 'nurse') {
            this.isNurseUser = true;
        }
        let patient_id: any;
        patient_id = this._route.snapshot.params.id || this._route.snapshot.params.patient_id || localStorage.getItem('patient_id');
        if (this.currentUser.user_type == global.USER_TYPE.BILLER && !patient_id) {
            patient_id = this.patient_id;
        }
        const userInfo = {
            id: this.currentUser._id,
            auth_key: this.currentUser.auth_key,
            usertype: this.currentUser.user_type,
            patient_id
        };
        let relation;

        const patientResponse: any = await this._patientService.getPatient(userInfo).toPromise();
        if (patientResponse.status === 200) {
    
               await this._patientService.getOnePatient_fromCompFacPatient({patient_id:patient_id,company_id:this.currentUser.company_id}).subscribe((res:any)=>{
                    relation=res?.data;
                    this.facilityService.getFacility(relation?.facility_id).subscribe((response: any) => {
                        if (response.status == 200) {

                            console.log("this.patientFacilityFromRelation : ");
                            this.patientFacilityFromRelation=response?.data;
                            
                            this.patient.facility_id_ref=response?.data; 

                            
                        
                        }
                    });
                })


                this.patient = new Patient(patientResponse.data.patient);
                this.recentNote = new Patient(patientResponse.data.recentNote);

                console.log('...patient 2',this.patient);
                if(this.patient.date_of_birth_d){
                    this.patient.date_of_birth_d = this.patient.date_of_birth_d.substr(0,10)
                }
                // if(this.patient.last_admit_date){
                //     const last_admit_date = moment.tz(this.patient.last_admit_date, "UTC").format('MMM DD, YYYY');
                //     this.patient.last_admit_date = last_admit_date;
                // }
                this.loadPCCApiData();
         
        }
        const {status, data} = await this.companyService.getCompanyName(this.currentUser.company_id).toPromise();
        if(status === 200){
            if(!data.company_type || data.company_type.toLowerCase() !== 'wound') {
               this.tabs = this.tabs.filter((tab) => {
                return tab.name !== 'Wounds'
               })
               this.matrixTabs = this.matrixTabs.filter((tab) => {
                return tab.name !== 'Wounds'
               })
               this.nonPCCtabs = this.nonPCCtabs.filter((tab) => {
                return tab.name !== 'Wounds'
               })
            }    
        }
        await this.initTabs();
        if(this.savedTabs.length !=this.tabs.length||this.savedTabs.length !=this.matrixTabs.length||this.savedTabs.length !=this.nonPCCtabs.length){
            await this.initTabs();
        }

    }
    ngOnDestroy() {
        if (this.dialogSubscription) {
            this._patientDetailService.onChangePatientAllergy(null);
            this.dialogSubscription.unsubscribe();
        }
    }
 
    getPatientDob(patient) {
        if(patient.date_of_birth) {
            const parts = patient.date_of_birth.split('-');
            return `${parts[1]}/${parts[2]}/${parts[0]}`;
        } else if(patient.date_of_birth_d) {
            return patient.date_of_birth_d;
        } else {
            return '01/01/1955';
        }
    }
    getLastSeen() {
        let company_id=this.currentUser?.company_id?.toString()
        if (window.location.pathname.includes('company')) {
            this.commonService.castCompany.subscribe(company=>{
                if(company){
                    company_id = company._id.toString();
                  }
            })
        }

        let last_seen='-';
        if(this.patient?.last_seen){
            if (Array.isArray(this.patient?.last_seen) && this.patient?.last_seen?.length) {
                let company_last_seen = this.patient.last_seen.filter(last_seen => last_seen.company_id.toString() == this.currentUser.company_id.toString())
                let lastSeenElement = company_last_seen
                    .filter(item => item.last_seen)
                    .map(item => ({
                        ...item,
                        date: new Date(item.last_seen.split(' - ')[1]) 
                    }))
                    .sort((a, b) => b.date.getTime() - a.date.getTime())
                    .at(0);
            
                last_seen = lastSeenElement?.last_seen || '';
            } else {
                last_seen = this.patient?.last_seen || '';
            }
        }
        return last_seen;

        //return  this.patient?.last_seen||'';

        // let lastSeen = '';
        // const { recentNote } = this.recentNote;
        // if (recentNote && recentNote.doctor_id_ref) {
    
        //   const { first_name, last_name } = recentNote.doctor_id_ref;
        //   lastSeen += `${first_name[0]}${last_name[0]}`.toUpperCase();
        //   // console.log("recentNote", recentNote);
        //   // lastSeen += ` - ${moment(new Date(recentNote.filterServiceDate).toLocaleString('en-US', { timeZone: recentNote.timezone })).format('M/D/YYYY')}`;
        //   if (recentNote.date_obj) {
        //     lastSeen += ` - ${this.commonService.dateObjToString(recentNote.date_obj, false)}`;
        //   }
        //   else {
        //     const [year, month, day] = this.commonService.convertDateToStringforMoment(moment(recentNote.filterServiceDate)).split("-");
        //     lastSeen += ` -${month}/${day}/${year}`;
        //   }
        // }
        // return lastSeen;
      }

    isWoundCompany(){
        return this.currentUser.company_type == 'Wound';
    }

    async loadPCCApiData() {
        const pccPatientID = this.patient.pcc_patientId;
        if (!pccPatientID) return;
    }

    goBack() {
        if(this.currentUser.user_type == '6') {
            this.closePatient.emit(false);
        }
        else {
        this.location.back();
        }
        
    }

    onEditClickAdmin(patientid){
            this._router.navigate([`/company/${this.companyId}/admin-patient-edit/${patientid}`]);
    }

    async getPatientFacility(patient){
        
        if(this.patientFacilityFromRelation){
            
            console.log("this.patientFacilityFromRelation.title : : ", this.patientFacilityFromRelation?.title);
            return this.patientFacilityFromRelation?.title;
        }   
        else return patient.facility_id_ref?.title
    }

    onEditClick(patient){
        patient.facility_id_ref=patient.facility_id_ref?._id;
        
        console.log("patient lc", JSON.stringify(patient));
        localStorage.setItem('editPatient',JSON.stringify(patient));
        this._router.navigate([`/patient-add`]);
    }

    isPermittedFor(permission) {
        return this.currentUser.permissions?.find(permissions => (permissions.key === permission)) != null;
    }

     private redirectToScriptSureModule(sessionToken, scriptSureLaunchUrl) {  
        this._router.navigate(['/patient-scriptsure'], {
            queryParams: {
                sessionToken: sessionToken,
                scriptSureLaunchUrl: scriptSureLaunchUrl,
                returnTo: this._router.url
            }
        });
    }  
    
    async getScriptSureEmail(scriptSureEmail?: string) {
        let captureEmailDialogRef = this.dialog.open(CaptureScriptSureEmailDialogComponent, {
            width: '600px',     
            data: {
            scriptSureEmail: scriptSureEmail
            }
        });
        let data = await captureEmailDialogRef.afterClosed().toPromise();
        return data;
    }
        
    async loginToScriptSure(data) {
        let response = await this._patientScriptSureService.vendorLogin({ 
            data: data 
        });
    
        if(response.status === 200) {
            this.redirectToScriptSureModule(response.data.sessionToken, response.data.scriptSureLaunchUrl);
        } else {
            this._toastr.error("Unable to login to ScriptSure: " + response.message);
        }
    }
        
    async openScriptSureModule(patient) {    
        try {
            this._toastr.info("Getting patient details...");
            patient.isScriptSureLoading = true;
            let response: any = await this.censusPatientListService.getPatientDetails(patient._id);
            if(response.status !== 200){
                this._toastr.error("Unable to load patient details.");
                return;
            }
            const patientDetails = response?.data;
    
            this._toastr.info("Getting facility details...");
            response = await this.facilityService.getFacilityAsync(patient.facility_id_ref._id);
            if(response.status !== 200){
                this._toastr.error("Unable to obtain facility details.");
                return;
            }
            const facility = response?.data;
    
            let scriptSureEmail = this.currentUser.scriptsure_email;   
            let loginData = undefined;
            if(!scriptSureEmail) {
                let scriptsureEmailResponse = await this.getScriptSureEmail();
                if(!scriptsureEmailResponse.scriptSureEmail){
                    this._toastr.error("A valid ScriptSure email is required to proceed.");
                    return;
                }
                scriptSureEmail = scriptsureEmailResponse.scriptSureEmail;
                loginData = scriptsureEmailResponse.loginData;
            } else {    
                this._toastr.info("Validating ScriptSure email " + scriptSureEmail + " is registered with ScriptSure...");
                response = await this.censusPatientListService.checkIfScriptSureEmailRegistered(scriptSureEmail);
                if(!response.data || !response.data.registered) {
                    this._toastr.error(scriptSureEmail + " is not registered with ScriptSure. Please provide a valid ScriptSure email.");
                    let data = await this.getScriptSureEmail(scriptSureEmail);
                    if(!data || !data.scriptSureEmail) {
                    this._toastr.error("A valid ScriptSure email is required to proceed.");
                    return;
                    }
                    scriptSureEmail = data.scriptSureEmail;
                    loginData = data.loginData;
                } else {
                    loginData = response.data.loginData;
                }
            }
    
            const dialogRef = this.dialog.open(CaptureScriptSurePatientDetailDialogComponent, {
                width: '600px',
                data: {
                    patient: patientDetails,
                    facility: facility
                }
            });
    
            const result = await dialogRef.afterClosed().toPromise();
            if(!result) {
                this._toastr.error("Patient details required to proceed.");
                return;
            }
            
            const data = {
                sessionToken: loginData.sessionToken,
                practiceId: loginData.currentPractice.id,
                doctorPrescriberId: loginData.passport.user,
                userId: this.currentUser._id,
                patientId: patient._id,
                address: result.address,
                city: result.city,
                state: result.state,
                zipCode: result.zipCode,
                gender: result.gender,
                dateOfBirth: result.dateOfBirth,
                firstName: result.firstName,
                lastName: result.lastName,
                phone: result.phoneNumber,
                scriptSureEmail: scriptSureEmail
            }
        
            if (patientDetails.download_drug_history_consent == null) {
                const dialogRef = this.dialog.open(DrugHistoryConsentDialog);
    
                dialogRef.afterClosed().subscribe(async result => {
                    if (result && result.saveClick === true) {
                    const updateResponse: any = await this.censusPatientListService.updatePatientDrugHistoryConsent(patient._id, result.consentGiven);
                    if (updateResponse.status !== 200) {
                        this._toastr.error("Unable to update patient drug history consent. Please try again later.")
                        return;
                    }
        
                    await this.loginToScriptSure(data);
                    }
                });
                return;
            }
            await this.loginToScriptSure(data);
        } catch (error) {
            console.error('Error in openScriptSureModule:', error);
            this._toastr.error('An unexpected error occurred while opening ScriptSure.');
        } finally {
            patient.isScriptSureLoading = false;
        }
    }

    getRecentPatientADTRecord(patient) {
        patient.adtRecords.sort((a, b) => new Date(b.effectiveDateTime).getTime() - new Date(a.effectiveDateTime).getTime())
        return patient.adtRecords[0];
    }
    public tabChange(tab,index,forPatients) {
        this.tab = tab.name;
        if (forPatients === 'pcc') {
            this.tabs.forEach((element, i) => {
                if (index !== i)
                    element.is_active = false
            });
        }
        if (forPatients === 'nonpcc') {
            this.nonPCCtabs.forEach((element, i) => {
                if (index !== i)
                    element.is_active = false
            });
        }
        if (forPatients === 'matrix') {
            this.matrixTabs.forEach((element, i) => {
                if (index !== i)
                    element.is_active = false
            });
        }
        tab.is_active = true;
    }
    drop(event: CdkDragDrop<string[]>) {
        var previousIndex = parseInt(event.previousContainer.id.replace("list-",""));
        var currentIndex = parseInt(event.container.id.replace("list-",""));
        if(!Number.isNaN(previousIndex) && !Number.isNaN(currentIndex) && previousIndex!=undefined && currentIndex!=undefined && previousIndex!=currentIndex){
            moveItemInArray(this.tabs, previousIndex, currentIndex);
            this._patientDetailService.addPatientTabSettings(this.tabs, 'pcc').subscribe((Response: any) => {
            if (Response.status == 200) {
                console.log('Tabs settings Saved');
            }
        });
        }
    }

    dropNonPCC(event: CdkDragDrop<string[]>) {
        var previousIndex = parseInt(event.previousContainer.id.replace("list-",""));
        var currentIndex = parseInt(event.container.id.replace("list-",""));
        if(!Number.isNaN(previousIndex) && !Number.isNaN(currentIndex) && previousIndex!=undefined && currentIndex!=undefined && previousIndex!=currentIndex){
            moveItemInArray(this.nonPCCtabs, previousIndex, currentIndex);
            this._patientDetailService.addPatientTabSettings(this.nonPCCtabs, 'nonpcc').subscribe((Response: any) => {
            if (Response.status == 200) {
                console.log('Tabs settings Saved');
            }
        });
        }
        // moveItemInArray(this.nonPCCtabs, event.previousIndex, event.currentIndex);
        // this._patientDetailService.addPatientTabSettings(this.nonPCCtabs, 'nonpcc').subscribe((Response: any) => {
        //     if (Response.status == 200) {
        //         console.log('Tabs settings Saved');
        //     }
        // });
    }
    dropMatrix(event: CdkDragDrop<string[]>) {
        var previousIndex = parseInt(event.previousContainer.id.replace("list-",""));
        var currentIndex = parseInt(event.container.id.replace("list-",""));
        if(!Number.isNaN(previousIndex) && !Number.isNaN(currentIndex) && previousIndex!=undefined && currentIndex!=undefined && previousIndex!=currentIndex){
            moveItemInArray(this.nonPCCtabs, previousIndex, currentIndex);
            this._patientDetailService.addPatientTabSettings(this.matrixTabs, 'matrix').subscribe((Response: any) => {
            if (Response.status == 200) {
                console.log('Tabs settings Saved');
            }
        });
        }
        // moveItemInArray(this.matrixTabs, event.previousIndex, event.currentIndex);
        // this._patientDetailService.addPatientTabSettings(this.matrixTabs, 'matrix').subscribe((Response: any) => {
        //     if (Response.status == 200) {
        //         console.log('Tabs settings Saved');
        //     }
        // });
    }

    async initTabs() {
        return new Promise<void>((resolve, reject) => {
            if (this.patient.pcc_patientId) {
                this._patientDetailService.getPatientTabSettings('pcc').subscribe(data => {
                    // @ts-ignore
                    if (data.data.length > 0) {
                        // @ts-ignore
                        let tabsData = data.data;
                        this.savedTabs = tabsData;
                        if (tabsData.length != this.tabs.length) {
                            this._patientDetailService.addPatientTabSettings(this.tabs, 'pcc').subscribe((Response: any) => {
                                if (Response.status == 200) {
                                    console.log('Tabs settings Saved');
                                }
                            });
                            return;
                        }
                        tabsData.forEach(data => {
                            if (data.name === 'Patient Notes') {
                                data.is_active = true;
                                this.tab = data.name;
                            } else {
                                data.is_active = false;
                            }
                            if (data.name.toLowerCase() === 'appointment') {
                                data.name = 'Encounter';
                            }
                        });
                        this.tabs = tabsData;
                    }
                    resolve();
                }, error => {
                    reject('error => ' + error.toString());
                });
            }
            if (this.patient.source === 'MatrixCare') {
                this._patientDetailService.getPatientTabSettings('matrix').subscribe(data => {
                    // @ts-ignore
                    if (data.data.length > 0) {
                        // @ts-ignore
                        let tabsData = data.data;
                        this.savedTabs = tabsData;
                        if (tabsData.length != this.matrixTabs.length) {
                            this._patientDetailService.addPatientTabSettings(this.matrixTabs, 'matrix').subscribe((Response: any) => {
                                if (Response.status == 200) {
                                    console.log('Tabs settings Saved');
                                }
                            });
                            return;
                        }
                        tabsData.forEach(data => {
                            if (data.name === 'Patient Notes') {
                                data.is_active = true;
                                this.tab = data.name;
                            } else {
                                data.is_active = false;
                            }
                            if (data.name.toLowerCase() === 'appointment') {
                                data.name = 'Encounter';
                            }
                        });
                        this.matrixTabs = tabsData;
                    }
                    resolve();
                }, error => {
                    reject('error => ' + error.toString());
                });
            }
            if (!this.patient.pcc_patientId) {
                this._patientDetailService.getPatientTabSettings('nonpcc').subscribe(data => {
                    // @ts-ignore
                    if (data.data.length > 0) {
                        // @ts-ignore
                        let tabsData = data.data;
                        this.savedTabs = tabsData;
                        if (tabsData.length != this.nonPCCtabs.length) {
                            this._patientDetailService.addPatientTabSettings(this.nonPCCtabs, 'nonpcc').subscribe((Response: any) => {
                                if (Response.status == 200) {
                                    console.log('Tabs settings Saved');
                                }
                            });
                            return;
                        }
                        tabsData.forEach(data => {
                            if (data.name === 'Patient Notes') {
                                data.is_active = true;
                                this.tab = data.name;
                            } else {
                                data.is_active = false;
                            }
                            if (data.name.toLowerCase() === 'appointment') {
                                data.name = 'Encounter';
                            }
                        });
                        this.nonPCCtabs = tabsData;
                    }
                    resolve();
                }, error => {
                    reject('error => ' + error.toString());
                });
            }

        });
    }
    openCreatePaitentAllergyDialog() {
        let options: any = {
            width: '50%',
            height: '45vh',
            data: {
                patientId: this.patient._id
            }
        }
        this.dialogSubscription = this.dialog.open(CreateNonPccAllergyIntolerancesDialogComponent, {
            ...options,
        }).afterClosed().subscribe((queryReport) => {
        });
    }
    getAllListConnections(tabArray, index){
        var connections = []
        for(var i=0;i<tabArray.length;i++){
          if(i!=index){
            connections.push("list-"+i);
          }
        }
        return connections;
    }
    
    async getCCD(patient){
        // console.log("in get CCD", patient)
        let obj = {
            _id: patient._id,
            gender: patient.gender,
            first_name : patient.first_name,
            middle_name : patient.middle_name,
            last_name : patient.last_name,
            date_of_birth : patient.date_of_birth,
            ssn : patient.patient_ssn,
            facility_id_ref : patient.facility_id_ref._id,
            facility_external_id : patient.facility_id_ref.external_id,
            matrix_payload: {
                patient_id: patient.matrix_payload.patient_id || "",
            } 
        }
        let res:any = await lastValueFrom(this._patientDetailService.getCCD(obj)) as any;
        console.log("in CCD : ", res)  
    }

    showFaceSheet: boolean = false;

    onFaceSheetClick() {
        if(this.currentUser.user_type == '6') {
            this.showFaceSheet = true;
        }
        else {
            this._router.navigate(['/facesheet'])
        }
    }

    onCloseFacesheet(event) {
        this.showFaceSheet = false;
    }
}
